import { render, staticRenderFns } from "./ListHolder.vue?vue&type=template&id=94fb449a&scoped=true&"
import script from "./ListHolder.vue?vue&type=script&lang=js&"
export * from "./ListHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fb449a",
  null
  
)

export default component.exports